import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import RootLayout from "./components/RootLayout.js";

// Pages
import LoginPageUsingEmail from "./pages/Loginpage/Loginpage.js";

import LoginPageUsingEmailPass from "./pages/Loginpage/Loginpage2.js";
import ParentSignup from "./pages/Loginpage/Parentlogin.js";
import ParentRegistration from"./pages/Loginpage/Parentsignupform.js";
import Feefrequency from "./pages/Feefrequency.js";
import Onetime from "./pages/Onetime.js";
import Monthly from "./pages/Monthly.js";
import Quaterly from "./pages/Quaterly.js";
import Termwise from "./pages/Termwise.js";
import Yearly from "./pages/Yearly.js";
import Coursewise from "./pages/Coursewise.js";
import FeeCategoryTable from "./pages/Feecategory.js";
import Registration from "./pages/Registration.js";
import Re_registration from "./pages/Reregistration.js";
import Collectpayment from "./pages/feemanagement/collectpayment.js";
import UpcomingFeeInvoices from "./pages/feemanagement/UpcomingInvoices.js";
import CollectFee from "./pages/feemanagement/CollectFee.js";
import AddArrears from "./pages/feemanagement/AddArrears.js";
import GenerateInvoice from "./pages/feemanagement/SelectStudent.js";
import PendingInvoices from "./pages/feemanagement/PendingInvoices.js";
import ViewInvoice from "./pages/feemanagement/ViewInvoice.js";
import CustomerTable from "./pages/feemanagement/Customer.js";
import GenerateSpecialInvoice from "./pages/feemanagement/Specialfeespage.js";
import PrintInvoice from "./pages/feemanagement/PrintInvoice.js";
import SendInvoice from "./pages/feemanagement/SendInvoice.js";
import CollectRegistrationFee from "./pages/feemanagement/CollectRegistrationFee.js";
import Tution from "./pages/Tution.js";
import Library from "./pages/Library.js";
import Miscellaneous from "./pages/Miscellaneous.js";
import Academic from "./pages/Academic.js";
import Book from "./pages/Book.js";
import Uniform from "./pages/Uniform.js";
import Sports from "./pages/Sports.js";
import E_learning from "./pages/Elearning.js";
import Createfee from "./pages/Createfee.js";
import Feestructure from "./pages/Feestruct/Feestructure.js";
import ViewFeeStructure from "./pages/Feestruct/ViewFeeStructure.js";
import ViewFeeStructure2 from "./pages/Feestruct/ViewFeeStructure2.js";
import Firstcard from "./pages/Feestruct/Firstcard.js";
import Secondcard from "./pages/Feestruct/Secondcard.js";
import Thirdcard from "./pages/Feestruct/Thirdcard.js";
import Fourthcard from "./pages/Feestruct/Fourthcard.js";
import Fifthcard from "./pages/Feestruct/Fifthcard.js";
import Sixthcard from "./pages/Feestruct/Sixthcard.js";
import Seventhcard from "./pages/Feestruct/Seventhcard.js";
import Eighthcard from "./pages/Feestruct/Eighthcard.js";
import Ninethcard from "./pages/Feestruct/Ninethcard.js";
import Tenthcard from "./pages/Feestruct/Tenthcard.js";
import Parentsnotification from "./pages/Parentnotification/Parentnotification.js";
import IntegrationSettings from "./pages/Integreation/Integration.js";
import FuelExpenseTable from "./pages/Vehicleexpenses/Fuelexpense.js";
import MH20ER4534 from "./pages/Vehicleexpenses/Firstbike.js";
import CreateVehicleFuel from "./pages/Vehicleexpenses/Createvehiclefuel.js";
import UpdateVehicleFuel from "./pages/Vehicleexpenses/Updatevehiclefuel.js";
import Vehiclemaintenances from "./pages/Vehicleexpenses/Vehiclemaintenances.js";
import Createvehiclemaintenance from "./pages/Vehicleexpenses/Createvehiclemaintenance.js";
import Updatevehiclemaintenance from "./pages/Vehicleexpenses/Updatevehiclemaintain.js";
import VehicleIncidentTable from "./pages/Vehicleexpenses/Vehicleincident.js";
import CreateVehicleIncident from "./pages/Vehicleexpenses/Createvehicleincident.js";
import VehicleIncidentDetail1 from "./pages/Vehicleexpenses/vehicleincidentdetail1.js";
import VehicleFineTable from "./pages/Vehicleexpenses/Vehiclefine.js";

// Accountant & Finance
import Accountant from "./pages/dashboard/Accountant.js";
import WalletSale from "./pages/Smartwallet/Wallet_sale.js";
import Wallet_Recharges from "./pages/Smartwallet/Wallet_Recharges.js";
import Failed_Wallet_Recharge from "./pages/Smartwallet/Failed_Wallet_Recharge.js";
import Bills from "./pages/BillsExpenses/Bills.js";
import CreateBill from "./pages/BillsExpenses/CreateBill.js";
import { PaidBills } from "./pages/BillsExpenses/PaidBills.js";
import { Suppliers } from "./pages/BillsExpenses/Suppliers.js";
import ViewBill from "./pages/BillsExpenses/ViewBill.js";
import EditBill from "./pages/BillsExpenses/EditBill.js";
import { PayBill } from "./pages/BillsExpenses/PayBill.js";
import ExpensesDashboard from "./pages/Expenses/ExpensesDashboard.js";
import Type from "./pages/Expenses/Type.js";

import { ExpenseType } from "./pages/Expenses/ExpenseType.js";
import OtherIncomes from "./pages/OtherIncomes/OtherIncomes.js";
import { IncomeType } from "./pages/OtherIncomes/IncomeType.js";

import Invoices from "./pages/Payment_application/Invoices.js";
import AllPendingInvoicesTable from "./pages/feemanagement/Allpendinginvoices.js";
import Paid from "./pages/Payment_application/Paid.js";
import Failed_Payments from "./pages/Payment_application/Failed_Payments.js";
import Failed_Transactions from "./pages/Parent_Transactions/Failed_Transactions.js";
import YearlyIncomeReport from "./pages/Reports/YearlyIncomeReport.js";

import Transaction_Receipt from "./pages/Smartwallet/Transaction_Receipt.js";
import New_Recharge from "./pages/Smartwallet/New_Recharge.js";
import Pending_Invoices_Invoice from "./pages/Payment_application/Pending_Invoices_Invoice.js";
import Payment_Details from "./pages/Payment_application/Payment_Details.js";
import CreateVehicleFine from "./pages/Vehicleexpenses/Createvehiclefine.js";
import VehicleFineDetail1 from "./pages/Vehicleexpenses/Vehiclefinedatail1.js";
import UpdateVehicleFine from "./pages/Vehicleexpenses/Updatevehiclefine.js";
import VehicleAccessoryTable from "./pages/Vehicleexpenses/Vehicleaccessory.js";
import CreateVehicleAccessory from "./pages/Vehicleexpenses/Createvehicleaccessory.js";
import VehicleAccessoryDetail1 from "./pages/Vehicleexpenses/Vehicleaccessorydetails1.js";
import UpdateVehicleAccessory from "./pages/Vehicleexpenses/Updatevehicleaccessory.js";
import VehicleSparepartsTable from "./pages/Vehicleexpenses/Vehiclespareparts.js";
import CreateVehicleSpareparts from "./pages/Vehicleexpenses/Createvehiclespareparts.js";
import VehicleSparepartsDetail1 from "./pages/Vehicleexpenses/Vehiclesparepartsdetail1.js";
import UpdateVehicleSpareparts from "./pages/Vehicleexpenses/Updatevehiclespareparts.js";
import ReceiptLayoutSettings from "./pages/Vehicleexpenses/Receipelayoutsetting.js";
import InvoiceLayoutSettings from "./pages/Vehicleexpenses/Invoicelayoutsetting.js";
import Transaction_Failed from "./pages/Parent_Transactions/Transaction_Failed.js";
import Reports from "./pages/Reports/Reports.js";
import Cashless_Balance_Report from "./pages/Reports/Cashless_Balance_Report.js";
import Wallet_Sales_Report from "./pages/Reports/Wallet_Sales_Report.js";
import Wallet_Sales_Report_Based from "./pages/Reports/Wallet_Sales_Report_Based.js";
import Vehicle_Expense_Report from "./pages/Reports/Vehicle_Expense_Report.js";
import Collection_Report from "./pages/Reports/Collection_Report.js";
import Invoice_Balance_Report from "./pages/Reports/Invoice_Balance_Report.js";
import Balance_Report from "./pages/Reports/Balance_Report.js";
import Transportation_Details from "./pages/Reports/Transportation_Details.js";
import FeeDueForSiblings from "./pages/Reports/Fee_Due_for_Siblings.js";
import Special_Fee_Report from "./pages/Reports/Special_Fee_Report.js";
import Payment_Mode_Report from "./pages/Reports/Payment_Mode_Report.js";
import PaymentReceipt from "./pages/Payment_application/PaymentReceipt.js";
import Receipt_invoice from "./pages/Payment_application/Receipt_invoice.js";
// import  AccountsType  from "./pages/Expenses/Type.js";
import  ExInvoicePage  from "./pages/feemanagement/Exampleviewinvoice.js";
// import ImportInvoice from "./pages/feemanagement/ViewInvoiceimp.js";
import ViewInvoiceimp from "./pages/feemanagement/ViewInvoiceimp.js";
import AddDicount from "./pages/feemanagement/AddDicount.js";
import CustomerViewInvoice from "./pages/feemanagement/CustomerViewInvoice.js";
import ViewInvoicePending from "./pages/feemanagement/ViewInvoicePending.js";
import ProfileAc from "./pages/profile/ProfileAc.js";
import ViewInvoiceCustomer from "./pages/feemanagement/ViewInvoiceCustomer.js";


const App = () => {
  return (
    <Router>
      <Routes>
         {/* ===================== Auth Pages (No RootLayout) ===================== */}
        <Route path="/loginpage" element={<LoginPageUsingEmail />} />
        <Route path="/login" element={<LoginPageUsingEmailPass />} />
        <Route path="/parentlogin" element={<ParentSignup />} />
        <Route path="/parentregistration" element={<ParentRegistration />} />

       <Route
          path="/*"
          element={
            <RootLayout>
              <Routes>
                <Route path="/" element={<Navigate to="/login" />} />

                {/* Fee Management */}
                
                <Route path="/feefrequency" element={<Feefrequency />} />
                <Route path="/onetime" element={<Onetime />} />
                <Route path="/monthly" element={<Monthly />} />
                <Route path="/quaterly" element={<Quaterly />} />
                <Route path="/termwise" element={<Termwise />} />
                <Route path="/yearly" element={<Yearly />} />
                <Route path="/coursewise" element={<Coursewise />} />
                <Route path="/feecategory" element={<FeeCategoryTable />} />
                <Route path="/registration/:id" element={<Registration />} />
                <Route path="/re_registration" element={<Re_registration />} />
                <Route
                  path="/accountant/payment/paymentReceipt"
                  element={<PaymentReceipt />}
                />
                <Route
                  path="/accountant/payment/Receipt_invoice/"
                  element={<Receipt_invoice />}
                />
                <Route
                  path="/accountant/receiptlayout"
                  element={<ReceiptLayoutSettings />}
                />
                <Route
                  path="/accountant/invoicelayout"
                  element={<InvoiceLayoutSettings />}
                />
                <Route
                  path="/accountant/parenttransactions/failedtransactionrecept/:id"
                  element={<Transaction_Failed />}
                />
                <Route path="/accountant/reports" element={<Reports />} />
                <Route
                  path="/accountant/wallet"
                  element={<Cashless_Balance_Report />}
                />
                <Route
                  path="/accountant/wallet/walletsale"
                  element={<Wallet_Sales_Report />}
                />
                <Route
                  path="/accountant/wallet/operatorsale"
                  element={<Wallet_Sales_Report_Based />}
                />
                <Route
                  path="/accountant/reports/expense/"
                  element={<Vehicle_Expense_Report />}
                />
                <Route
                  path="/accountant/reports/expense/collection/"
                  element={<Collection_Report />}
                />
                <Route
                  path="/accountant/reports/invoice"
                  element={<Invoice_Balance_Report />}
                />
                <Route
                  path="/accountant/reports/balance"
                  element={<Balance_Report />}
                />
                <Route
                  path="/accountant/reports/billing/"
                  element={<Transportation_Details />}
                />
                <Route
                  path="/accountant/reports/siblings"
                  element={<FeeDueForSiblings />}
                />
                <Route
                  path="/accountant/reports/specialfee"
                  element={<Special_Fee_Report />}
                />
                <Route
                  path="/accountant/reports/parentstransaction"
                  element={<Payment_Mode_Report />}
                />

                <Route path="/collectpayment" element={<Collectpayment />} />
                <Route path="/upcominginvoices" element={<UpcomingFeeInvoices />} />
                <Route path="/collectfee" element={<CollectFee />} />
                <Route path="/addarrears" element={<AddArrears />} />
                <Route path="/selectstudent" element={<GenerateInvoice />} />
                <Route path="/customer" element={<CustomerTable />} />
                <Route path="/1111" element={<AllPendingInvoicesTable />} />
                <Route path="/pendinginvoices" element={<PendingInvoices />} />
                <Route path="/viewinvoice/:id" element={<ViewInvoice />} />
                <Route path="/ViewInvoiceCustomer/:id" element={<ViewInvoiceCustomer />} />
                <Route path="/Pendingviewinvoice/:id" element={<ViewInvoicePending />} />
                <Route path="/CustomerViewInvoice/:id" element={<CustomerViewInvoice />} />
                <Route path="/specialfee" element={<GenerateSpecialInvoice />} />
                <Route path="/AddDicount/:id" element={<AddDicount />} />
                <Route path="/printinvoice" element={<PrintInvoice />} />
                <Route path="/sendinvoice" element={<SendInvoice />} />
                <Route
                  path="/collectregistrationfee"
                  element={<CollectRegistrationFee />}
                />
                {/* <Route path="/Loginpage" element={<LoginPage />} /> */}
                <Route path="/accountant/New_Recharge" element={<New_Recharge />} />
                <Route
                  path="/accountant/invoice/Pending_Invoices_Invoice"
                  element={<Pending_Invoices_Invoice />}
                />
                <Route
                  path="//accountant/failedtransaction/Payment Details"
                  element={<Payment_Details />}
                />
                <Route
                  path="/accountant/reports/expense/feepaid"
                  element={<YearlyIncomeReport />}
                />

                {/* Dashboard */}
                <Route path="/accountant" element={<Accountant />} />
                <Route path="/accountant/wallet_sale" element={<WalletSale />} />
                <Route path="/walletreceipt" element={<Transaction_Receipt />} />
                <Route
                  path="/accountant/wallet_recharges"
                  element={<Wallet_Recharges />}
                />
                <Route
                  path="/accountant/failed_recharge"
                  element={<Failed_Wallet_Recharge />}
                />
                <Route path="/accountant/bill" element={<Bills />} />
                <Route path="/accountant/createbill/:id" element={<CreateBill />} />
                <Route path="/accountant/createbill" element={<CreateBill />} />
                <Route path="/accountant/paidbills" element={<PaidBills />} />
                <Route path="/accountant/suppliers" element={<Suppliers />} />
                <Route path="/accountant/viewbill/:id" element={<ViewBill />} />
                <Route path="/accountant/editbill" element={<EditBill />} />
                <Route path="/accountant/paybill" element={<PayBill />} />
                <Route path="/accountant/expenses" element={<ExpensesDashboard />} />
                <Route path="/accountant/ExpenseType" element={<ExpenseType />} />
                <Route path="/accountant/IncomeType" element={<IncomeType />} />
 <Route path="/accountant/Type" element={<Type />} />




            

                {/* Other Pages */}
                <Route path="/tution" element={<Tution />} />
                <Route path="/library" element={<Library />} />
                <Route path="/miscellaneous" element={<Miscellaneous />} />
                <Route path="/academic" element={<Academic />} />
                <Route path="/book" element={<Book />} />
                <Route path="/uniform" element={<Uniform />} />
                <Route path="/sports" element={<Sports />} />
                <Route path="/e_learning" element={<E_learning />} />
                <Route path="/createfee/:id" element={<Createfee />} />
                <Route path="/createfee" element={<Createfee />} />
                <Route path="/import-invoice" element={<ViewInvoiceimp />} />
                <Route path="/feestructure" element={<Feestructure />} />
                <Route path="/viewfeestructure/:id" element={<ViewFeeStructure />} />
                <Route path="/viewfeestructure2/:id" element={<ViewFeeStructure2 />} />
                <Route path="/firstcard/:id" element={<Firstcard />} />
                <Route path="/view-fee-structure" element={<ViewFeeStructure />} />
                <Route path="/secondcard" element={<Secondcard />} />
                <Route path="/thirdcard" element={<Thirdcard />} />
                <Route path="/fourthcard" element={<Fourthcard />} />
                <Route path="/fifthcard" element={<Fifthcard />} />
                <Route path="/sixthcard" element={<Sixthcard />} />
                <Route path="/seventhcard" element={<Seventhcard />} />
                <Route path="/eighthcard" element={<Eighthcard />} />
                <Route path="/ninethcard" element={<Ninethcard />} />
                <Route path="/tenthcard" element={<Tenthcard />} />
                <Route
                  path="/parentsnotification"
                  element={<Parentsnotification />}
                />
                <Route path="/integration" element={<IntegrationSettings />} />

                {/* Vehicle Expenses */}
                <Route path="/fuelexpense" element={<FuelExpenseTable />} />
                <Route path="/mh20er4534" element={<MH20ER4534 />} />
                <Route path="/createvehiclefuel" element={<CreateVehicleFuel />} />
                <Route path="/updatevehiclefuel" element={<UpdateVehicleFuel />} />
                <Route path="/accountant/vehiclemaintenance" element={<Vehiclemaintenances/>} />
                <Route path="/accountant/createvehiclemaintenance" element={<Createvehiclemaintenance/>} />
                <Route path="/accountant/updatevehiclemaintenance" element={<Updatevehiclemaintenance/>} />
                <Route path="/accountant/vehicleincident" element={<VehicleIncidentTable/>} />
                <Route path="/accountant/createvehicleincident" element={<CreateVehicleIncident/>} />
                <Route path="/Test Vehicle" element={<VehicleIncidentDetail1/>} />
                <Route path="/accountant/vehiclefine" element={<VehicleFineTable/>} />
                <Route path="/accountant/createvehiclefine" element={<CreateVehicleFine/>} />
                <Route path="/New Vehicle" element={<VehicleFineDetail1/>} />
                <Route path="/updatevehiclefine" element={<UpdateVehicleFine/>} />
                <Route path="/accountant/vehicleaccessory" element={<VehicleAccessoryTable/>} />
                <Route path="/createvehicleaccessory" element={<CreateVehicleAccessory/>} />
                <Route path="/Safe Student" element={<VehicleAccessoryDetail1/>} />
                <Route path="/accountant/updatevehicleaccessory" element={<UpdateVehicleAccessory/>} />
                <Route path="/accountant/vehiclespareparts" element={<VehicleSparepartsTable/>} />
                <Route path="/accountant/createvehiclespareparts" element={<CreateVehicleSpareparts/>} />
                <Route path="/Uber Vehicle" element={<VehicleSparepartsDetail1/>} />
                <Route path="/updatevehiclespareparts" element={<UpdateVehicleSpareparts/>} />
                


                 <Route path="/demoinvoice" element={<ExInvoicePage/>} />
                 {/* <Route path="ViewInvoice" element={<ViewInvoice />} /> */}
                <Route path="/accountant/PrintInvoice" element={<PrintInvoice />} />
                <Route path="/accountant/SendInvoice" element={<SendInvoice />} />
                <Route
                  path="/CollectRegistrationFee"
                  element={<CollectRegistrationFee />}
                />
                <Route path="/accountant/invoice" element={<Invoices />} />
                <Route path="/accountant/payment" element={<Paid />} />
                <Route path="/accountant/OtherIncomes" element={<OtherIncomes />} />
                <Route path="/accountant/failedpayment" element={<Failed_Payments />} />
                <Route path="/accountant/parenttransactions/failedpending" element={<Failed_Transactions />} />

                <Route path="/accountant/OtherIncomes" element={<OtherIncomes />} />
                <Route
                  path="/accountant/failedpayment"
                  element={<Failed_Payments />}
                />
                <Route
                  path="/accountant/parenttransactions/failedpending"
                  element={<Failed_Transactions />}
                />

                {/* profile section */}
                <Route
                  path="/accountant/profile"
                  element={<ProfileAc />}
                />
              </Routes>
            </RootLayout>
          }
        />

      </Routes>
    </Router>
  );
};

export default App;
